import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class EstatePlanningType extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {number}
   */
  estateId;

  /**
   * @var {?string}
   */
  type;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.type = model.type;
  }
}
